import FC24 from '../assetts/icons/fc24.avif';
import FC25 from '../assetts/icons/fc25.jpg';
import UFC24 from '../assetts/images/ufc5.avif';
import UFC23 from '../assetts/icons/ufc4.png';
import MortalCombat1 from '../assetts/images/mortalcombo1.png';
import MortalCombat from '../assetts/icons/mortolcombot.jpg';
import FC23 from '../assetts/icons/fifa23.avif';
import Pess13 from '../assetts/icons/pess13.jpg';
import UFC3 from '../assetts/icons/uf3.jpg';
import Tekken from '../assetts/icons/tekken.jpg';
import UNCHARTED from '../assetts/images/UNCHARTED.jpeg';
import SPIDER from '../assetts/images/spiderman.webp';
import TURISMO from '../assetts/images/gran.jpg';
import HORIZON from '../assetts/images/horizon.avif';

const games = [
  {
    title: 'EA SPORTS FC™ 24',
    description: 'FC™ 24.',
    image: FC24,
  },
  {
    title: 'EA SPORTS FC™ 25',
    description: 'FC™ 25.',
    image: FC25,
  },
  {
    title: 'EA SPORTS™ FIFA 23',
    description: 'FIFA 23',
    image: FC23,
  },
  {
    title: 'EA SPORTS UFC 3',
    description: 'UFC 3',
    image: UFC3,
  },
  {
    title: 'EA SPORTS UFC 4',
    description: 'UFC 4',
    image: UFC23,
  },
  {
    title: 'EA SPORTS UFC 5',
    description: 'UFC 5',
    image: UFC24,
  },

  {
    title: 'MORTAL KOMBAT 1',
    description: 'Kombat Pack',
    image: MortalCombat1,
  },
  {
    title: 'MORTAL KOMBAT 11',
    description: 'Kombat Pack 2',
    image: MortalCombat,
  },

  {
    title: 'PRO EVOLUTION SOCCER 2013',
    description: 'PES 2013',
    image: Pess13,
  },
  {
    title: 'TEKKEN 7',
    description: 'Единоборства, Боевики',
    image: Tekken,
  },

  {
    title: 'UNCHARTED 4',
    description: 'Путь вора',
    image: UNCHARTED,
  },
  {
    title: 'MARVEL S SPIDER-MAN',
    description: 'Marvel',
    image: SPIDER,
  },
  {
    title: 'GRAN TURISMO',
    description: 'Gran Turismo',
    image: TURISMO,
  },
  {
    title: 'HORIZON ZERO DAWN',
    description: 'Zero dawn',
    image: HORIZON,
  },
];

export default games;
